import React from 'react';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';

import BulkAction from './BulkAction';
import PropTypes from 'prop-types';

const CommunicationMenu = ({
  search,
  filterType,
  filterContactIds,
  contactTotal,
  schoolYearId,
  active,
  selectableContactTypes,
  ...props
}) => {
  const modalOpts = filterType === 'include' ? {
    type: 'email',
    contactIds: filterContactIds,
    schoolYearId,
    selectableContactTypes: selectableContactTypes,
  } : {
    type: 'email',
    search,
    filterType,
    filterContactIds,
    schoolYearId,
    total: filterType === 'exclude' ? contactTotal - filterContactIds.length : contactTotal,
    selectableContactTypes: selectableContactTypes,
  };

  const actions = [
    <BulkAction
      icon={faEnvelope}
      title='Send Email'
      onClick={() => window.ReactComponent.renderCommunicationWorkflow($('.communication-modal').get(0), modalOpts)}
    />
  ];

  return(<React.Fragment>
      <div className="communication-modal" />

      {active ? <BulkAction type='comm-menu' icon={faBullhorn} title='Communicate' menuTitle='Communicate' {...props}>
        {React.Children.map(actions, (child) => React.cloneElement(child, { ...props }))}
      </BulkAction> : ''}

    </React.Fragment>
  );
};


CommunicationMenu.propTypes = {
  /** The search we want to run our bulk action against */
  search: PropTypes.arrayOf(
    PropTypes.shape({
      criterion: PropTypes.string,
      modifier: PropTypes.string,
      value: PropTypes.arrayOf(PropTypes.string)
    })
  ),

  /**
   * The type of search filter to apply with filterContactIds. Possible values: default, include, exclude
   *
   * include: apply only to filterContactIds
   * exclude: apply to search result _except_ filterContactIds
   * default: use search result without ID filters
   */
  filterType: PropTypes.string,

  /**
   * A List of Contact IDs to filter search against
   */
  filterContactIds: PropTypes.arrayOf(PropTypes.string),

  contactTotal: PropTypes.number,
  schoolYearId: PropTypes.string,
};

CommunicationMenu.defaultProps = {
  search: [],
  filterType: '',
  filterContactIds: [],
  contactTotal: 0,
  schoolYearId: '',
  showModal: () => false,
};

export default CommunicationMenu;
